import request from '@/utils/request'

/**
 * 根据id查询菜单及其子菜单
 * @param {string} 菜单id
 */
export function getById(id) {
  return request({
    url: `/sysPermission/getById/${id}`,
    method: 'post'
  })
}

export function getPerMissionById(id) {
  return request({
    url: `/sysPermission/getPerMissionById/${id}`,
    method: 'post'
  })
}

export function modify(permission) {
  return request({
    url: '/sysPermission/modify',
    method: 'post',
    data: permission
  })
}

export function treeList() {
  return request({
    url: '/sysPermission/treeList',
    method: 'post'
  })
}

export function del(id) {
  return request({
    url: `/sysPermission/del/${id}`,
    method: 'post'
  })
}
